"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decryption = exports.encryption = exports.clipboard = exports.base64ToBlob = exports.downloadFile = exports.qrcode = exports.$once = exports.$on = exports.$emit = exports.$bus = exports.timeGap = void 0;
// 实用小工具
var events_1 = require("events");
var qrcode_1 = __importDefault(require("qrcode"));
var clipboard_1 = __importDefault(require("clipboard"));
var lodash_1 = require("lodash");
var crypto_js_1 = __importStar(require("crypto-js"));
/**
 * @description 计算日期差 常用于聊天评论回复等
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {number} timeStamp 传入需要计算的10位(秒级)或13位(毫秒级)时间戳 建议使用10位时间戳
 * @param {validity} timeStamp 计算有效期的(秒级)时间戳 如时间超过1天后不进行计算 则传入60 * 60 * 24 = 86400
 * @param {funtion} callback 如果您指定了```validity```参数 对于不符合时间差的日期 我们将调用此callback进行处理
 * @returns {unknown} unknown
 * @example
 * timeGap(Date.now() - 1)                                  //传入与发布时间相差0~1秒的时间戳
 * timeGap(Date.now() - 1 * 1000)                           //传入与发布时间相差1~59秒的时间戳
 * timeGap(Date.now() - 23 * 1000)                          //传入与发布时间相差1~59秒的时间戳:
 * timeGap(Date.now() - 60 * 30 * 1000)                     //传入与发布时间相差1~59分的时间戳
 * timeGap(Date.now() - 60 * 60 * 12 * 1000)                //传入与发布时间相差1~24小时的时间戳
 * timeGap(Date.now() - 60 * 60 * 24 * 8 * 1000)            //传入与发布时间相差1~30天的时间戳
 * timeGap(Date.now() - 60 * 60 * 24 * 30 * 7 * 1000)       //传入与发布时间相差1~12个月的时间戳
 * timeGap(Date.now() - 60 * 60 * 24 * 30 * 12 * 2 * 1000)  //传入与发布时间相差1年以上的时间戳
 * timeGap(Date.now() - 93312000, 62208000, (timeStamp) => new Date(timeStamp).toLocaleString().replace(/:\d{1,2}$/, ' ')) //传入与发布时间相差3年的时间戳 相差超过2年的执行custom callback
 */
var timeGap = function (timeStamp, validity, callback) {
    if (timeStamp.toString().length === 13) {
        timeStamp = Number(parseInt((timeStamp / 1000).toString()));
    }
    var difference = parseInt((Date.now() / 1000).toString()) - timeStamp;
    if (validity && difference > validity) {
        return callback && callback(timeStamp * 1000);
    }
    var secondTimeStamp = 1;
    var minuteTimeStamp = secondTimeStamp * 60;
    var hourTimeStamp = minuteTimeStamp * 60;
    var dayTimeStamp = hourTimeStamp * 24;
    var monthTimeStamp = dayTimeStamp * 30;
    var yearTimeStamp = monthTimeStamp * 12;
    if (difference >= secondTimeStamp && difference < minuteTimeStamp) {
        return difference + "\u79D2\u524D";
    }
    else if (difference >= minuteTimeStamp && difference < hourTimeStamp) {
        return Math.floor(difference / minuteTimeStamp) + "\u5206\u949F\u524D";
    }
    else if (difference >= hourTimeStamp && difference < dayTimeStamp) {
        return Math.floor(difference / hourTimeStamp) + "\u5C0F\u65F6\u524D";
    }
    else if (difference >= dayTimeStamp && difference < monthTimeStamp) {
        return Math.floor(difference / dayTimeStamp) + "\u5929\u524D";
    }
    else if (difference >= monthTimeStamp && difference < yearTimeStamp) {
        return Math.floor(difference / monthTimeStamp) + "\u4E2A\u6708\u524D";
    }
    else if (difference >= yearTimeStamp) {
        return Math.floor(difference / yearTimeStamp) + "\u5E74\u524D";
    }
    else {
        return '刚刚';
    }
};
exports.timeGap = timeGap;
/**
 * @description 基于node-EventEmitter的事件总成 详情 https://github.com/nodejs/node/blob/v16.6.0/lib/events.js
 *
 * 特别注意：在发布事件前 需要保证该事件已被订阅 且订阅事件的组件已经加载 否则将会订阅失败
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @returns {EventEmitter} EventEmitter实例
 * @example
 * // 发布事件
 * $bus.emit('pageChange', '最靓的仔');
 *
 * // 订阅事件
 * $bus.on('pageChange', e => {
 *      console.log(e) // output 最靓的仔
 * });
 *
 * //其他使用方法请参考node文档
 */
exports.$bus = new events_1.EventEmitter();
/**
 * @description 发布事件的语法糖 详情 https://github.com/nodejs/node/blob/v16.6.0/lib/events.js
 *
 * 特别注意：在发布事件前 需要保证该事件已被订阅 且订阅事件的组件已经加载 否则将会订阅失败
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {string | symbol} eventName 要发布事件名称
 * @param {any[]} args  事件所附带的参数
 * @returns {boolean} 事件是否发布成功
 * @example
 * // 发布事件
 * $emit('pageChange', '最靓的仔');
 */
var $emit = function (eventName) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return exports.$bus.emit(eventName, args);
};
exports.$emit = $emit;
/**
 * @description 订阅事件的语法糖 详情 https://github.com/nodejs/node/blob/v16.6.0/lib/events.js
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {string | symbol} eventName 要订阅事件名称
 * @param {(...args: any[]) => void} listener 事件触发后回调 参数为发布事件时传递的参数
 * @returns {EventEmitter} EventEmitter实例
 * @example
 * // 订阅事件
 * $on('pageChange', e => {
 *      console.log(e) // output 最靓的仔
 * });
 */
var $on = function (eventName, listener) { return exports.$bus.on(eventName, listener); };
exports.$on = $on;
/**
 * @description 订阅事件的语法糖 ```此方法只订阅一次``` 详情 https://github.com/nodejs/node/blob/v16.6.0/lib/events.js
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {string | symbol} eventName 要订阅事件名称
 * @param {(...args: any[]) => void} listener 事件触发后回调 参数为发布事件时传递的参数
 * @returns {EventEmitter} EventEmitter实例
 * @example
 * // 订阅事件 (只订阅一次)
 * $once('pageChange', e => {
 *      console.log(e) // output 最靓的仔
 * });
 */
var $once = function (eventName, listener) { return exports.$bus.once(eventName, listener); };
exports.$once = $once;
/**
 * @description 生成二维码 详情 https://github.com/soldair/node-qrcode
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {string | QRCodeSegment[]} text 传入的文本
 * @param {QRCodeToDataURLOptions} options 配置项 选填
 * @returns {Promise<string>} 返回Promise对象 若成功则返回base64 否则返回失败原因
 * @example
 * qrcode(
 *      '二维码内容',   //此项是必填的 下面的配置项是可选的
 *      {
 *        type: 'image/png',
 *        rendererOpts: { quality: 0.9 },
 *        margin: 0,
 *        width: 200,
 *        color: { dark: 'A0D911ff', light: '#ffffffff' }
 *      }
 *     )
 */
var qrcode = function (text, options) {
    return qrcode_1.default.toDataURL(text, options);
};
exports.qrcode = qrcode;
/**
 * @description 利用Blob下载文件 不兼容IE 团战可以输 IE必须死！ 详情 https://developer.mozilla.org/zh-CN/docs/Web/API/Blob
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {BlobPart[] | undefined} blobParts 二进制对象 同Blob
 * @param {BlobPropertyBag | undefined} options 配置项 选填 同Blob
 * @param {string} fileName 下载的文件名 默认 file
 * @returns {void} 无返回值 会直接下载文件
 * @example
 * downloadFile(['二进制文本'], options, 'logo');
 */
var downloadFile = function (blobParts, options, fileName) {
    if (fileName === void 0) { fileName = 'file'; }
    var blob = new Blob(blobParts, options);
    var a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(a.href);
    a.remove();
};
exports.downloadFile = downloadFile;
/**
 * @description 将base64转换为blob
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {string} content base64文本
 * @returns {[Uint8Array[], { type: string }]} 返回一个数组 第一个元素为转换好的blob对象  第二个元素为该文件的类型
 *
 * 可以配合```downloadFile```使用
 * @example
 * const [blobParts, options] = base64ToBlob('base64文本');
 * downloadFile(blobParts, options, '最靓的仔');
 */
var base64ToBlob = function (content) {
    var _a = content.split(';base64,'), part = _a[0], atob = _a[1];
    var _b = part.split(':'), _ = _b[0], contentType = _b[1];
    var raw = window.atob(atob);
    var rawLength = raw.length;
    var uInt8Array = new Uint8Array(rawLength);
    for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return [[uInt8Array], { type: contentType }];
};
exports.base64ToBlob = base64ToBlob;
/**
 * @description 点击当前元素复制文字到剪切板 通用版本
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {element} HTMLElement Html元素 必须是一个真实的dom 不要传递任何class 或 id选择器
 * @param {string} text 要复制的文字 注意 只能是字符串
 * @param {(e: Clipboard.Event) => void} success 可选 复制成功后的回调 可以进行toast提示
 * @param {(e: Clipboard.Event) => void} error 可选 复制失败后的回调 可以进行toast提示
 * @returns {void} 无返回值
 * @example
 * clipboard(
 *   document.getElementById('xxx')
 *   '要复制的文本~',
 *   e => console.log(e, '复制成功'),
 *   e => console.log(e, '复制失败,请手动复制')
 * )
 */
var clipboard = function (element, text, success, error) {
    var clipboardIns = new clipboard_1.default(element);
    var id = element.getAttribute('id');
    var attributes = [
        { qualifiedName: 'id', value: id !== null && id !== void 0 ? id : lodash_1.uniqueId("clipboard_" + Date.now() + "_") },
        { qualifiedName: 'data-clipboard-text', value: text },
    ];
    attributes.forEach(function (_a) {
        var qualifiedName = _a.qualifiedName, value = _a.value;
        element.setAttribute(qualifiedName, value);
    });
    clipboardIns.on('success', function (e) {
        success && success(e);
        e.clearSelection();
    });
    clipboardIns.on('error', function (e) { return error && error(e); });
};
exports.clipboard = clipboard;
/**
 * @description 对数据进行加密 详情 https://github.com/brix/crypto-js
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {encryptionType} type 加密的类型 如果值是AES或MD5会返回加密好的字符串 否则返回crypto实例
 * @param {string} message 要加密的文字
 * @param {string} key 加密用的秘钥 会自动进行utf8编码 仅AES方式需要此key
 * @returns {string | typeof cryptoJS} 已加密的字符串或cryptoJS实例
 * @example
 * encryption('MD5', '张三丰');  //output 4a6042865bf82a8311bc5fc53d7fc9fe
 * encryption('AES', '张三丰');  //output WBV+1iTfGk1eN2hxaWY/AA==
 *
 */
var encryption = function (type, message, key) {
    if (key === void 0) { key = 'ae0e4bda'; }
    switch (type) {
        case 'AES':
            return crypto_js_1.AES.encrypt(message, crypto_js_1.enc.Utf8.parse(key), {
                mode: crypto_js_1.mode.ECB,
                padding: crypto_js_1.pad.Pkcs7
            }).toString();
        case 'MD5':
            return crypto_js_1.MD5(message).toString();
        default:
            return crypto_js_1.default;
    }
};
exports.encryption = encryption;
/**
 * @description 对数据进行解密 详情 https://github.com/brix/crypto-js
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {decryptionType} type 解密的类型 如果值是AES会返回解密好的字符串 否则返回crypto实例
 * @param {string} message 要解密的内容
 * @param {string} key 解密用的秘钥 应当与加密时的秘钥一致 否则会解密失败 仅AES方式需要此key
 *
 * 特别注意：每一种加密模式的密码长度都不相同 如果解密失败 优先检查密码长度是否符合要求
 * @returns {string | typeof cryptoJS} 已解密的字符串或cryptoJS实例
 * @example
 * decryption('AES', 'WBV+1iTfGk1eN2hxaWY/AA=='); //output 张三丰
 */
var decryption = function (type, message, key) {
    if (key === void 0) { key = 'ae0e4bda'; }
    switch (type) {
        case 'AES':
            return crypto_js_1.AES.decrypt(message, crypto_js_1.enc.Utf8.parse(key), {
                mode: crypto_js_1.mode.ECB,
                padding: crypto_js_1.pad.Pkcs7
            }).toString(crypto_js_1.enc.Utf8);
        default:
            return crypto_js_1.default;
    }
};
exports.decryption = decryption;
